export default "__VITE_ASSET__D3Fvkxb6__"